import { render, staticRenderFns } from "./products-list.vue?vue&type=template&id=0b087004"
import script from "./products-list.vue?vue&type=script&lang=js"
export * from "./products-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports